"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { InfoCard } from "@/components/ui/info-card";
import { getProgramImageMeta } from "@/content/program-images";
import { getProgramInfoCardAccent } from "@/lib/program-info-card-theme";
import { cn } from "@/lib/utils";

interface ProgramInfoCardProps {
  slug: string;
  title: string;
  description: string;
  image?: string;
  accentIndex?: number;
  className?: string;
}

export function ProgramInfoCard({
  slug,
  title,
  description,
  image,
  accentIndex = 0,
  className,
}: ProgramInfoCardProps) {
  const meta = getProgramImageMeta(slug);
  const src = image ?? meta.src;
  const accent = getProgramInfoCardAccent(slug, accentIndex);

  return (
    <Link
      href={`/programs/${slug}`}
      className={cn(
        "group block h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--charity-green)] focus-visible:ring-offset-2",
        className
      )}
    >
      <InfoCard
        responsive
        image={src}
        title={title}
        description={description}
        borderColor={accent}
        effectBgColor={accent}
        borderBgColor="var(--info-card-border-bg)"
        cardBgColor="var(--info-card-bg)"
        shadowColor="var(--info-card-shadow)"
        textColor="var(--info-card-text)"
        hoverTextColor="var(--info-card-hover-text)"
        patternColor1="var(--info-card-pattern-1)"
        patternColor2="var(--info-card-pattern-2)"
        contentPadding="12px 16px"
        className="h-full transition-transform duration-300 group-hover:-translate-y-1"
      />
      <span className="sr-only">
        Learn more about {title}
        <ArrowRight className="inline" aria-hidden />
      </span>
    </Link>
  );
}
